import React, { useEffect, useState, useRef } from 'react';
import {
  ScrollView,
  View,
  Text,
  TouchableOpacity,
  StyleSheet,
  Platform,
  KeyboardAvoidingView,
  BackHandler,
} from 'react-native';
import { useDispatch, useSelector } from 'react-redux';
import { Picker } from '@react-native-picker/picker';
import { OutlinedTextField } from 'react-native-material-textfield';
import { useNavigation, useRoute } from '@react-navigation/native';
import colors from '../../theme/Colors';
import ImageUploader from './UploadProfileImage';
import { isBlank, isDesktop, isIOS, isPresent } from '../../utils/BooleanUtility';
import { ids, styles } from './styles';
import { AnalyticsManager, EventParameterKey, EventType } from '../../analytics';
import Config from '../../libraries/ReactNativeConfig';
import DesktopHeaderLogo from '../shared/DesktopHeaderLogo';
import SaveProfileButton from './SaveProfileButton';
import { REMOTE_CONFIG_KEYS } from '../../config/Constants';
import { StaticNavigationHeader } from '../shared';
import HandleSelectionShimmer from './HandleSelectionShimmer';
import Header from './Header';
import RemoteConfig from '../../utils/RemoteConfig';
import { jsonParser } from '../../utils/JsonUtility';
import { SCREEN_CONSTANTS } from '../../config/ScreenConstants';
import { withEither } from '../../lib/Monads';
import DropDownPicker from 'react-native-dropdown-picker';
import { getScreenWidth } from '../../utils/LayoutUtility';
import { editProfile } from '../../actions/ActionTypes';
import { getStoreRef } from '../../store/StoreUtility';

const PlatformAwareKeyboardAvoidingView = withEither(
  isIOS,
  KeyboardAvoidingView,
)(View);

export default function ProfileSelection(props) {
  const {
    id: currentUserId = '',
    profile: { name: profileName = '', email: profileEmail = '', image: profileImage = '' },
    profile = {},
  } = useSelector((state) => state.UserAccountInfo);

  const [isLoading, setIsLoading] = useState(true);
  const [image, setImage] = useState(profileImage || '');
  const [imageBase64String, setImageBase64String] = useState('');
  const [name, setName] = useState(profileName || '');
  const [nameError, setNameError] = useState('');
  const [prefixOpen, setPrefixOpen] = useState(false);
  const [email, setEmail] = useState(profileEmail || '');
  const [emailError, setEmailError] = useState('');
  const [isCtaActionLoading, setIsCtaActionLoading] = useState(false);
  const dispatch = useDispatch();
  const scrollViewRef = useRef(null);
  const nameInputRef = useRef(null); // Ref for the Full Name input field
  const emailInputRef = useRef(null);
  const navigation = useNavigation();
  const headerData = jsonParser(RemoteConfig.getValue(REMOTE_CONFIG_KEYS.dermat_onbaord_pages_Header_text)) || {};
  const headerTitle = headerData['profileSelection']?.title;
  const headerSubtitle = headerData['profileSelection']?.subtitle;
  const description = headerData['description']?.description;
  const {
    route: { params: { navigateToMessageInbox, isUserSelfiePresent } = {} } = {},
  } = props;
  const state = getStoreRef().getState();

  useEffect(() => {
    // Add an event listener for the hardware back button press
    BackHandler.addEventListener('hardwareBackPress', handleBackButton);

    // Clean up the event listener when the component unmounts
    return () => {
      BackHandler.removeEventListener('hardwareBackPress', handleBackButton);
    };
  }, []);


  const handleBackButton = () => {
    navigation.goBack();
    return true;
  };


  useEffect(() => {
    if (isPresent(name)) {
      nameInputRef?.current?.focus();
    }
  }, [name]);
  useEffect(() => {
    if (isPresent(email)) {
      emailInputRef?.current?.focus();
    }
  }, [email]);

  const scrollToIndex = (value) => {
    if (scrollViewRef && scrollViewRef.current) {
      scrollViewRef.current.scrollTo(value);
    }
  };
  const validateEmail = () => {
    const re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  };

  const onContinuePress = () => {
    setIsCtaActionLoading(true);
    const isValid = validateEmail();
    if (isBlank(name)) {
      setNameError('Please Enter Your Name');
      setIsCtaActionLoading(false);
      return;
    }
    if (!isValid) {
      setEmailError('Please Enter Valid Email');
      setIsCtaActionLoading(false);
      return;
    }
    const user = {
      name,
      email,
      image: imageBase64String,
    };
    dispatch(
      editProfile(user, '', (callbackData, success) => {
        if (success) {
          setIsCtaActionLoading(false);
          const cometChatData = state.UserAccountInfo?.cometChatUserInfo?.data;
          const cometChatAuthToken = cometChatData?.attributes?.authToken;
          if (isUserSelfiePresent) {
            navigation.navigate(Config.PROFILE_PIC_ROUTE);
            return;
          }
          navigateToMessageInbox('replace');
          // this.profileUpdateSuccess();
        } else {
          this.toast.show('Some error occurred. Please try again');
        }
      }),
    );
  };

  const goBack = () => {
    navigation.goBack();
  };

  const handlePress = () => {
    navigation.push('TabNavigator');
  };

  const handlePostInsertImage = () => {
    AnalyticsManager.logEvent(EventType.INFLUENCER.PROFILE_PIC_UPLOAD, {
      current_user_id: currentUserId,
    });
  };

  const setProfileImage = (imageUrl, base64String) => {
    setImage(imageUrl);
    setImageBase64String(base64String);
  };



  const handleTextField = (text) => {
    if (isPresent(nameError)) {
      setNameError('');
    }
    setName(text);
  };

  const handleEmailTextField = (text) => {
    if (isPresent(emailError)) {
      setEmailError('');
    }
    setEmail(text);
  };

  const nameTextFieldLabelOffset = { x1: -10, y1: -30, y0: -8 };
  const nameTextFieldContentInset = { input: 8 };
  const emailTextFieldLabelOffset = { x1: -10, y1: -30, y0: -8 };
  const emailTextFieldContentInset = { input: 8 };
  return (
    <PlatformAwareKeyboardAvoidingView style={styles.container}>
      {isDesktop() && (
        <TouchableOpacity style={styles.logoContainer} onPress={handlePress}>
          <DesktopHeaderLogo />
        </TouchableOpacity>
      )}
      <View style={styles.container} dataSet={{ media: ids.container }}>
        {isDesktop() && <Header title={headerTitle} subtitle={headerSubtitle} />}
        {!isDesktop() && <StaticNavigationHeader onBackPress={goBack} title={headerTitle} subtitle={headerSubtitle} />}
        <ScrollView style={styles.scrollView} ref={scrollViewRef}>
          <View dataSet={{ media: ids.formContainer }}>
            <ImageUploader
              image={image}
              setImage={setProfileImage}
              postInsertImage={handlePostInsertImage}
              subText={description}
              captionTextStyle={handleStyles.captionText}
            />
            <View style={handleStyles.nameTextInputStyle}>
              <OutlinedTextField
                label='Full Name*'
                tintColor={colors.subtitle}
                inputContainerStyle={styles.textInputContainerStyle}
                lineWidth={0}
                activeLineWidth={0}
                labelOffset={nameTextFieldLabelOffset}
                contentInset={nameTextFieldContentInset}
                value={name}
                onChangeText={handleTextField}
                error={nameError}
                ref={nameInputRef} // Assigning ref to Full Name input field
              />
            </View>
            <View style={handleStyles.emailTextInputStyle}>
              <OutlinedTextField
                label='Your Email*'
                tintColor={colors.subtitle}
                inputContainerStyle={styles.textInputContainerStyle}
                lineWidth={0}
                activeLineWidth={0}
                labelOffset={emailTextFieldLabelOffset}
                contentInset={emailTextFieldContentInset}
                value={email}
                onChangeText={handleEmailTextField}
                error={emailError}
                ref={emailInputRef} // Assigning ref to Full Name input field
              />
            </View>
            <View style={styles.verticalSpace} />
          </View>
        </ScrollView>
        <SaveProfileButton
          onPress={onContinuePress}
          loading={isCtaActionLoading}
          screenName={SCREEN_CONSTANTS.HANDLE_SELECTION}
          buttonColor={Config.PRIMARY_ACTION_COLOR_BACKGROUND_COLOR || colors.black}
        />
      </View>
    </PlatformAwareKeyboardAvoidingView>
  );
}


const handleStyles = StyleSheet.create({
  prefixPicker: {
    backgroundColor: colors.white,
    borderWidth: 1,
    borderColor: '#00000024',
    width: 90,
    height: 50,
    top: 14,
    left: -12,
    paddingVertical: 14,
    paddingHorizontal: 10,
    borderRadius: 8,
  },
  dropdownContainer: {
    borderColor: '#d3d3d3',
    borderRadius: 5,
    width: getScreenWidth() / 2,
    backgroundColor: colors.white,
  },
  arrowIcon: {
    tintColor: colors.foxyBlack,
    // height: 20,
  },
  listItemContainer: {
    backgroundColor: colors.white,
    zIndex: 998, // Ensures that the list items are above other components
  },
  text: {
    color: colors.foxyBlack,
    width: 30,
    alignSelf: 'center',
    fontSize: 16,
    fontFamily: 'Roboto-Medium',
  },
  descriptionTextField: {
    padding: 16,
    height: 150,
    overflow: 'hidden',
  },
  multilineTextInputContainerStyle: {
    borderWidth: 1,
    borderColor: colors.subtitle,
    borderRadius: 8,
    padding: 8,
    height: '100%',
    overflow: 'hidden',
  },
  nameTextInputStyle: {
    paddingHorizontal: 12,
    zIndex: 1000,
    paddingTop: 10,
  },
  emailTextInputStyle: {
    paddingVertical: 18,
    paddingHorizontal: 12,
    zIndex: 1000,
  },
  captionText: {
    color: Config.THEME_COLOR || colors.black,
    fontSize: 14,
    marginTop: 16,
    fontFamily: 'Roboto-Regular',
    alignSelf: 'flex-start',
    width: getScreenWidth() - 24,
    marginLeft: 14,
  },
});
